.peep-recurring-task-controls {
    position: absolute;
    top: -2px;
    right: -10px; /* Offsets 10px padding for bigger click target */
}
